"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.futuresReducer = void 0;
var _redux = require("redux");
var _futuresKVPInfoReducer = require("./futuresKVPInfoReducer");
var _systemFuturesEnabledReducer = require("./systemFuturesEnabledReducer");
var _futuresAccountInfoReducer = require("./futuresAccountInfoReducer");
var _futuresInstrumentsReducer = require("./futuresInstrumentsReducer");
var _futuresProductsReducer = require("./futuresProductsReducer");
var _futuresBalancesReducer = require("./futuresBalancesReducer");
var _futuresPositionsReducer = require("./futuresPositionsReducer");
var _futuresContractDetailsReducer = require("./futuresContractDetailsReducer");
var _futuresAccountMaxQuantityReducer = require("./futuresAccountMaxQuantityReducer");
var _futuresLevel1Reducer = require("./futuresLevel1Reducer");
var _futuresLevel2Reducer = require("./futuresLevel2Reducer");
var _futuresLeveragesReducer = require("./futuresLeveragesReducer");
var _futuresTickersReducer = require("./futuresTickersReducer");
var _futuresRecentTradesReducer = require("./futuresRecentTradesReducer");
var _futuresOrdersReducer = require("./futuresOrdersReducer");
var _futuresOrderCostReducer = require("./futuresOrderCostReducer");
var futuresReducer = exports.futuresReducer = (0, _redux.combineReducers)({
  level1: _futuresLevel1Reducer.futuresLevel1,
  level2: _futuresLevel2Reducer.futuresLevel2,
  futuresKVPInfo: _futuresKVPInfoReducer.futuresKVPInfoReducer,
  systemFuturesEnabled: _systemFuturesEnabledReducer.systemFuturesEnabledReducer,
  accountInfo: _futuresAccountInfoReducer.futuresAccountInfoReducer,
  instruments: _futuresInstrumentsReducer.futuresInstumentsReducer,
  products: _futuresProductsReducer.futuresProductsReducer,
  balances: _futuresBalancesReducer.futuresBalancesReducer,
  positions: _futuresPositionsReducer.futuresPositionsReducer,
  contractDetails: _futuresContractDetailsReducer.futuresContractDetailsReducer,
  accountMaxQuantity: _futuresAccountMaxQuantityReducer.futuresAccountMaxQuantityReducer,
  leverages: _futuresLeveragesReducer.futuresLeveragesReducer,
  tickers: _futuresTickersReducer.futuresTickersReducer,
  recentTrades: _futuresRecentTradesReducer.recentTradesReducer,
  orders: _futuresOrdersReducer.futuresOrdersReducer,
  futuresOrderCostInfo: _futuresOrderCostReducer.futuresOrderCostReducer
});